import React from "react";

import { Action, Category } from "constants/events";
import { Brand } from "custom-types/Brand";
import { useEventTracker } from "hooks/useEventTracker";

import TrackImpression from "components/TrackImpression";

import BrandCoin from "./BrandCoin";

type Props = {
  title?: string;
  brands: Brand[];
  eventCategory: Category;
  eventLabel: string;
};

const BrandCoinCarousel: React.FC<Props> = ({
  title,
  brands,
  eventCategory,
  eventLabel,
}) => {
  const { publishEvent } = useEventTracker();

  if (!brands || !brands.length) {
    return <></>;
  }

  return (
    <div>
      {title && <h2 className="heading--m font-extrabold">{title}</h2>}
      <div className="-mx-lg p-sm pb-md overflow-x-scroll lg:overflow-x-visible">
        <ul className="inline-flex lg:flex -mr-sm lg:mr-none">
          {brands.map((brand) => (
            <li
              key={brand.name}
              className="mx-sm flex-shrink-0"
              style={{ minWidth: 80, width: 80 }}
              data-testid="brand__coin-list-item"
            >
              <TrackImpression
                category={eventCategory}
                label={eventLabel}
                customDimensions={{ brandId: brand.id }}
              >
                <BrandCoin
                  brand={brand}
                  data-testid="link-test"
                  onClick={() => {
                    publishEvent({
                      action: Action.click,
                      brandId: brand.id,
                      category: eventCategory,
                      label: eventLabel,
                    });
                  }}
                />
              </TrackImpression>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BrandCoinCarousel;
